<template>
  <div class="users-list-page">
    <div class="global-header-wrap">
      <div class="user-header-left">
        <div class="left-part">
          <span>{{ $t("user.userName") }}</span>
          <div class="listSearch">
            <el-input
              v-model="text"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch('text')"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>{{ $t("user.phone") }}</span>
          <div class="listSearch">
            <el-input
              v-model="phone"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch('phone')"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>{{ $t("user.email") }}</span>
          <div class="listSearch">
            <el-input
              v-model="email"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch('email')"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>{{ $t("user.mac") }}</span>
          <div class="listSearch">
            <el-input
              v-model="mac"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch('mac')"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <button class="global-button-style" @click="search()">
          {{ $t("commonMsg.search") }}
        </button>
      </div>
      <div class="right-part">
        <button
          v-if="isAdmin"
          class="global-button-style"
          @click="$router.push({ name: 'add' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("user.addUser") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header" class="user-table-header">
        <p>用户总数：{{ total ? total : 0 }}</p>
        <button
          v-if="isAdmin"
          class="global-button-style"
          @click="exportUserData"
        >
          导出
        </button>
      </div>
      <div class="global-body-wrap" v-loading="loading">
        <AppTable
          :tableProps="tableProps"
          :tableData="tableData"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
        @pageSize="pageSize"
        :pageSizes="true"
      />
    </el-card>

    <CbModel
      :showCb="showCb"
      :userItem="userItem"
      @close="showCb = false"
    ></CbModel>
    <OssModel
      :showOss="showOss"
      :userId="checkUserId"
      @close="(showOss = false), (checkUserId = '')"
    ></OssModel>
    <LibraryModel
      :showLibrary="showLibrary"
      :userItem="userItem"
      @close="showLibrary = false"
    ></LibraryModel>
    <PushFileModel
      :showPushFile="showPushFile"
      :userItem="userItem"
      @close="showPushFile = false"
    ></PushFileModel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import CbModel from "./components/cbModal/index.vue";
import OssModel from "./components/ossModal/index.vue";
import LibraryModel from "./components/libraryModel/index.vue";
import PushFileModel from "./components/pushFileModel/index.vue";
export default {
  name: "Users",
  components: {
    AppTable,
    Pagination,
    CbModel,
    OssModel,
    LibraryModel,
    PushFileModel,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    isAdmin() {
      return this.userInfo.roleValue === 1;
    },
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: this.$t("user.name"),
        },
        {
          prop: "id",
          label: this.$t("user.id"),
        },
        {
          prop: "nickname",
          label: this.$t("user.nicknameOld"),
        },
        {
          prop: "nickname1",
          label: this.$t("user.nickname"),
        },
        {
          prop: "email",
          label: this.$t("user.email"),
        },
        {
          prop: "phone",
          label: this.$t("user.phone"),
        },
        {
          prop: "storage_used",
          label: this.$t("user.storageLimit"),
        },
        {
          prop: "role_name",
          label: this.$t("user.role"),
        },
        // {
        //   prop: "userPowerRole",
        //   label: "权限角色",
        // },
        {
          prop: "user_devices",
          label: this.$t("user.devices"),
        },
        {
          prop: "handle",
          label: this.$t("org.manage"),
          width: this.isAdmin ? 680 : 160,
          btn: this.isAdmin
            ? [
                this.$t("commonMsg.edit"),
                "Token失效",
                "数据清理邮件",
                this.$t("commonMsg.destroy"),
                this.$t("commonMsg.correction"),
                "笔记PDF修正",
                "OSS查询",
                "CB查询",
                "书库查询",
                "推送查询",
              ]
            : [this.$t("commonMsg.correction"), "笔记PDF修正"],
        },
      ];
      return tableProps;
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      text: "",
      email: "",
      phone: "",
      mac: "",
      paramsList: { limit: 20, offset: 0, orderBy: "storage_used" },
      loading: false,
      checkUserId: "",
      sortData: [],
      showOss: false,
      userItem: null,
      showCb: false,
      showLibrary: false,
      showPushFile: false,
    };
  },
  methods: {
    regEmail(email) {
      if (email && String(email).indexOf("@") > 0) {
        const str = email.split("@");
        let _s = "";

        if (str[0].length > 3) {
          for (var i = 0; i < str[0].length - 3; i++) {
            _s += "*";
          }
        }

        return str[0].substr(0, 3) + _s + "@" + str[1];
      }

      return email;
    },

    regMobile(mobile) {
      if (mobile && mobile.length > 7) {
        return mobile.substr(0, 3) + "****" + mobile.substr(7);
      }

      return mobile;
    },

    async getUsers() {
      try {
        const res = await this.$http.getUsers(this.paramsList);
        this.total = res.data.count;
        if (!this.isAdmin) {
          for (let i of res.data.rows) {
            i.phone = this.regMobile(i.phone);
            i.email = this.regEmail(i.email);
          }
        }
        this.tableData = res.data.rows;
      } catch (error) {
        console.log(error);
      }
    },

    async exportUserData() {
      this.loading = true;
      try {
        let res = await this.$http.exportUserData();
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        document.body.appendChild(tempLink);
        tempLink.setAttribute("href", res.data);
        tempLink.click();
        document.body.removeChild(tempLink);
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    search() {
      this.paramsList.offset = 0;
      // this.text ? (this.paramsList.text = this.text) : "";
      // this.email ? (this.paramsList.email = this.email) : "";
      // this.phone ? (this.paramsList.phone = this.phone) : "";
      // this.mac ? (this.paramsList.mac = this.mac) : "";

      if (this.text) {
        this.paramsList.text = this.text;
      } else {
        delete this.paramsList.text;
      }

      if (this.email) {
        this.paramsList.email = this.email;
      } else {
        delete this.paramsList.email;
      }

      if (this.phone) {
        this.paramsList.phone = this.phone;
      } else {
        delete this.paramsList.phone;
      }

      if (this.mac) {
        this.paramsList.mac = this.mac;
      } else {
        delete this.paramsList.mac;
      }

      this.getUsers();
    },

    clearSearch(type) {
      switch (type) {
        case "text":
          this.text = "";
          delete this.paramsList.text;
          break;
        case "email":
          this.email = "";
          delete this.paramsList.email;
          break;
        case "phone":
          this.phone = "";
          delete this.paramsList.phone;
          break;
        case "mac":
          this.mac = "";
          delete this.paramsList.mac;
          break;
        default:
          break;
      }
      this.paramsList.offset = 0;
      this.getUsers();
    },

    async tableHandle(obj) {
      if (obj.type === this.$t("commonMsg.edit")) {
        this.$router.push({ name: "add", query: { editId: obj.data.row.id } });
      } else if (obj.type === this.$t("commonMsg.destroy")) {
        this.deleteUsers(obj.data.row.id);
      } else if (obj.type === this.$t("commonMsg.correction")) {
        this.correctionStorageSize(obj.data.row.id);
      } else if (obj.type === "Token失效") {
        this.disableToken(obj.data.row.id);
      } else if (obj.type === "数据清理邮件") {
        this.sendClearEmail(obj.data.row);
      } else if (obj.type === "笔记PDF修正") {
        this.correctionPDF(obj.data.row.id);
      } else if (obj.type === "OSS查询") {
        this.checkUserId = obj.data.row.id;
        this.showOss = true;
      } else if (obj.type === "CB查询") {
        this.userItem = obj.data.row;
        this.showCb = true;
      } else if (obj.type === "书库查询") {
        this.userItem = obj.data.row;
        this.showLibrary = true;
      } else if (obj.type === "推送查询") {
        this.userItem = obj.data.row;
        this.showPushFile = true;
      }
    },

    async sendClearEmail(row) {
      try {
        const res = await this.$prompt("请确认用户邮箱", "Tip", {
          inputValue: row.email,
          inputPattern:
            /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: "邮箱格式不正确",
        });
        await this.$http.sendClearEmail({ uid: row.uid, email: res.value });
        this.$message({
          type: "success",
          message: "发送成功",
        });
      } catch (error) {}
    },

    disableToken(userId) {
      this.$http
        .disableToken({ userId })
        .then((res) => {
          this.getUsers();
          this.$message({
            type: "success",
            message: this.$t("alertMsg.success"),
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.response.data.message,
          });
        });
    },

    async deleteUsers(id) {
      await this.$confirm(null, "确认执行注销操作？", {
        confirmButtonText: this.$t("commonMsg.confirm"),
        cancelButtonText: this.$t("commonMsg.cancel"),
        showClose: false,
        center: true,
      });
      this.$http
        .destroyUsers({ id: id })
        .then((res) => {
          this.getUsers();
          this.$message({
            type: "success",
            message: this.$t("alertMsg.delSuccess"),
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.response.data.message,
          });
        });
    },

    correctionStorageSize(id) {
      this.$http
        .calibration({ userId: id })
        .then((res) => {
          this.getUsers();
          this.$message({
            type: "success",
            message: this.$t("alertMsg.success"),
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.response.data.message,
          });
        });
    },

    correctionPDF(id) {
      this.$http
        .delRepeat({ userId: id })
        .then((res) => {
          this.getUsers();
          this.$message({
            type: "success",
            message: this.$t("alertMsg.success"),
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.response.data.message,
          });
        });
    },

    pageNum(val) {
      this.paramsList.offset = (val - 1) * this.paramsList.limit;
      this.getUsers();
    },

    pageSize(size) {
      this.paramsList.limit = size;
      this.getUsers();
    },

    async clearDB() {
      return new Promise(async (resolve, reject) => {
        try {
          let r = await indexedDB.databases();
          for (let i of r) {
            indexedDB.deleteDatabase(i.name);
          }
          // this.$cookie.remove("SyncGatewaySession");
          resolve("ok");
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  destroyed() {
    this.clearDB();
  },
  mounted() {
    this.getUsers();
  },
};
</script>

<style lang="scss" scoped>
.global-header-wrap {
  padding: 10px 44px;
}
.global-button-style {
  margin-top: 20px;
  margin-left: 0;
}
.users-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .user-header-left {
    width: calc(100% - 120px);
    float: left;
  }
  .left-part {
    float: left;
    margin-right: 20px;
    .listSearch {
      .el-input {
        width: 150px;
        .search-icon {
          font-size: 22px;
          cursor: pointer;
        }
      }
    }
    > span {
      margin-right: 10px;
      font-size: 14px;
    }
    .global-button-style {
      margin: 0;
    }
  }
}
.user-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > .global-button-style {
    margin-top: 0;
  }
}
</style>
